import { AsyncPipe, JsonPipe, NgForOf } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, DestroyRef, inject, OnInit } from '@angular/core';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslocoModule } from '@ngneat/transloco';
import { Store } from '@ngrx/store';
import { TuiButtonModule, TuiDialogContext, TuiSvgModule, TuiTextfieldControllerModule } from '@taiga-ui/core';
import { TuiRadioBlockModule } from '@taiga-ui/kit';
import { POLYMORPHEUS_CONTEXT } from '@tinkoff/ng-polymorpheus';
import { CartActions } from '@us/web/cart/data-access';
import { OrdersActions } from '@us/web/orders/data-access';
import { PaymentType } from '@us/web/shared/data-access';
import { selectPaymentSettingsMpos } from '@us/web/shop/data-access';
import { filter, map } from 'rxjs';

@Component({
    selector: 'us-qrpayment-mpos-options',
    templateUrl: './qrpayment-mpos-options.component.html',
    styleUrls: ['./qrpayment-mpos-options.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [
        TranslocoModule,
        FormsModule,
        ReactiveFormsModule,
        AsyncPipe,
        JsonPipe,
        NgForOf,
        TuiTextfieldControllerModule,
        TuiRadioBlockModule,
        TuiSvgModule,
        TuiButtonModule
    ]
})
export class QrPaymentMposOptionsComponent implements OnInit {
    readonly store = inject(Store);
    readonly context = inject(POLYMORPHEUS_CONTEXT) as TuiDialogContext<boolean, any>;
    readonly optionsQr$ = this.store.select(selectPaymentSettingsMpos).pipe(
        map(mpos => {
            return mpos?.qr_types || [];
        })
    );

    orderId = computed(() => {
        return this.context?.data?.order_id || null;
    })

    width = 300;

    paymentType = computed(() => {
        return this.context?.data?.payment_type || PaymentType.Mpos;
    });

    isUpdatePayment = computed(() => {
        return this.context?.data?.is_update_payment || false;
    });

    paymentQrCtrl = new FormControl<any>(null);

    ngOnInit(): void {
        this.paymentQrCtrl.valueChanges
            .pipe(filter(value => value !== null && value !== undefined && value !== ''))
            .subscribe((value: string) => {
                if (this.isUpdatePayment() && this.orderId()) {
                    this.store.dispatch(
                        OrdersActions.updatePaymentMethod({
                            orderId: this.orderId(),
                            paymentType: this.paymentType(),
                            payment_detail: {
                                code: 0,
                                message: '',
                                data: {
                                    qr_type: value
                                },
                            }
                        })
                    );
                    this.context.completeWith(true);
                    return;
                }
                this.store.dispatch(
                    CartActions.updateCart({
                        payment_type: this.paymentType(),
                        payment_detail: {
                            code: 0,
                            message: '',
                            data: {
                                qr_type: value
                            },
                        }
                    })
                );
                this.context.completeWith(true);
            });
    }
}
